export const SSL_DNS_INTERVALS = [
  { label: 'Every 5 minutes', value: 'PT5M' },
  { label: 'Every 8 hours', value: 'PT8H' },
  { label: 'Every 12 hours', value: 'PT12H' },
  { label: 'Every 24 hours', value: 'PT24H' },
];

export const WHOIS_INTERVALS = [
  { label: 'Every 24 hours', value: 'PT24H' },
];

export function intervalToMinutes(isoDuration) {
  if (isoDuration == null || isoDuration === '') {
    return 0;
  }

  const iso = String(isoDuration).trim();
  const match = iso.match(/^PT(?:(\d+)H)?(?:(\d+)M)?$/i);
  if (match) {
    return Number(match[1] || 0) * 60 + Number(match[2] || 0);
  }

  const numeric = Number(iso);
  return Number.isFinite(numeric) ? numeric * 60 : 0;
}

export function formatMonitoringInterval(isoDuration) {
  const minutes = intervalToMinutes(isoDuration);
  if (minutes <= 0) {
    return isoDuration || '';
  }
  if (minutes < 60) {
    return minutes === 1 ? '1 minute' : `${minutes} minutes`;
  }

  const hours = minutes / 60;
  return hours === 1 ? '1 hour' : `${hours} hours`;
}
